// Helper function to check whether a filename corresponds to a valid image
function isValidImage(filename) {
    if (!filename) return false;
    // Define the valid image extensions (lowercase)
    const validExtensions = ['png', 'jpg', 'jpeg', 'gif', 'dzi'];
    // Extract the file extension
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1) return false;
    const ext = filename.substring(dotIndex + 1).toLowerCase();
    return validExtensions.includes(ext);
}

function replaceExtensionWithDzi(imageUrl) {
    const urlWithoutExtension = imageUrl.substring(0, imageUrl.lastIndexOf('.'));
    return `${urlWithoutExtension}.dzi`;
}

function correctImageUrl(filename) {
    if (filename.startsWith('Icono\\') || filename.startsWith('icono\\')) {
        filename = filename.substring(6);
    }
    if (filename.startsWith('\\vm-iconopat\\')) {
        filename = filename.substring(13);
    }    
    if (filename.startsWith('Objets\\')) {
        filename = "media\\" + filename.substring(7);
    }
    return filename;
}

function correctImageUrlForDzi(filename) {
    if (filename.startsWith('\\vm-iconopat\\')) {
        filename = 'icono\\' + filename.substring(13);
    }
    return filename;
}

function getMainImageOld(record) {
    let filename = '';
    if (record?.data?.Record?.source === "icono") {
        if (record?.data?.Record?.IImages?.image2) {
            filename = record.data.Record.IImages.image2;
        }
    } else {
        if (record?.data?.Record?.Image?.image2) {
            filename = record.data.Record.Image.image2;
        }
    }

    return filename ? correctImageUrl(filename) : null;
}

function getMainImage(record) {
    let image = "";

    if (record?.data?.Record?.source === "objects") {
        if (record?.data?.Record?.Image) {
            const imageObj = record.data.Record.Image;
            image = imageObj.image2 ?? "noimage/pas-dimage-white.png";
        } else {
            image = "Icono/ICONOTHEQUE/pas-dimage-white.cci";
        }
    }

    if (record?.data?.Record?.source === "icono") {
        if (record?.data?.Record?.IImages) {
            const imageObj = record.data.Record.IImages;
            image = imageObj.image2 ?? "noimage/pas-dimage-white.png";
        } else {
            image = "Icono/ICONOTHEQUE/pas-dimage-white.cci";
        }
    }

    return image;
}

function getAdditionalImages(record) {
    let additionalImages = [];

    if (record?.data?.Record?.source === "objects") {
        if (Array.isArray(record?.data?.Record?.ImagesMoreObj)) {
            additionalImages = record.data.Record.ImagesMoreObj.map((imageObj) => ({
                imagesmore: imageObj.image2 ?? "noimage/pas-dimage-white.png",
                rank: imageObj.rank ?? "9999"
            }));
        } else if (record?.data?.Record?.ImagesMoreObj) {
            const imageObj = record.data.Record.ImagesMoreObj;
            additionalImages = [{
                imagesmore: imageObj.image2 ?? "noimage/pas-dimage-white.png",
                rank: imageObj.rank ?? "9999"
            }];
        }
    }

    if (record?.data?.Record?.source === "icono") {
        if (Array.isArray(record?.data?.Record?.ImagesMore)) {
            additionalImages = record.data.Record.ImagesMore.map((imageObj) => ({
                imagesmore: imageObj.image2 ?? "noimage/pas-dimage-white.cci",
                rank: imageObj.rank ?? "9999"
            }));
        } else if (record?.data?.Record?.ImagesMore) {
            const imageObj = record.data.Record.ImagesMore;
            additionalImages = [{
                imagesmore: imageObj.image2 ?? "noimage/pas-dimage-white.png",
                rank: imageObj.rank ?? "9999"
            }];
        }
    }

    return additionalImages.sort((a, b) => parseInt(a.rank) - parseInt(b.rank));
}

// Modified getImageParameters() with an image validity check
function getImageParameters(showType, filename) {
    let finalFilename;
    if (showType === 'dzi') {
        // For dzi, use the alternate correction function
        finalFilename = correctImageUrlForDzi(filename);
    } else {
        finalFilename = correctImageUrl(filename);
    }

    // Skip files that are not valid images.
    if (!isValidImage(finalFilename)) {
        return null;
    }

    let url = '';
    switch (showType) {
        case 'icon':
            url = generateImageUrl(finalFilename, showType, { width: 240, height: 160 });
            return { url };
        case 'iconscroll':
            url = generateImageUrl(finalFilename, showType, { width: 180 });
            return { url };
        case 'list':
            url = generateImageUrl(finalFilename, showType, { width: 220 });
            return { url };
        case 'mobilelist':
            url = generateImageUrl(finalFilename, showType, { width: 240, height: 120 });
            return { url };
        case 'mobilerecord':
            url = generateImageUrl(finalFilename, showType, { width: 640 });
            return { url };
        case 'filmstrip':
            url = generateImageUrl(finalFilename, showType, { height: 100 });
            return { url };
        case 'pdf':
            url = generateImageUrl(finalFilename, showType, { width: 440 });
            return { url };
        case 'dzi':
            // For dzi images, generate the proxy URL and then replace the extension with .dzi.
            url = replaceExtensionWithDzi(generateImageUrl(finalFilename, showType, {}));
            return { url };
        default:
            url = generateImageUrl(finalFilename, showType, {});
            return { url };
    }
}

function generateImageUrl(filename, showType, parameters) {
    if (showType === 'dzi') {
        return `https://collections.quaibranly.fr/cc/imageproxy.ashx?server=localhost&port=15012&filename=${filename}`;
    }

    const queryParams = [];
    if (parameters.width) queryParams.push(`width=${parameters.width}`);
    if (parameters.height) queryParams.push(`height=${parameters.height}`);
    const queryString = queryParams.length > 0 ? `&${queryParams.join('&')}` : '';
    return `https://collections.quaibranly.fr/ccImageProxy.ashx?filename=img/${filename}${queryString}`;
}

export function getImages(record) {
    const mainImage = getMainImage(record);
    const additionalImages = getAdditionalImages(record);

    const showTypes = ['icon', 'iconscroll', 'list', 'mobilelist', 'mobilerecord', 'filmstrip', 'pdf', 'dzi'];

    const result = {};

    showTypes.forEach(showType => {
        let images = [];
        // Generate parameters for the main image (if any)
        const mainImageParameters = mainImage ? getImageParameters(showType, mainImage) : null;
        if (mainImageParameters && mainImageParameters.url) {
            images.push({
                url: mainImageParameters.url,
                rank: 'main',
            });
        }
        // For each additional image, only push it if it yields valid image parameters.
        additionalImages.forEach(image => {
            const additionalImageParameters = getImageParameters(showType, image.imagesmore);
            if (additionalImageParameters && additionalImageParameters.url) {
                images.push({
                    url: additionalImageParameters.url,
                    rank: image.rank,
                });
            }
        });
        // If there are no images, add the fallback "no image" placeholder.
        if (images.length === 0) {
            const fallbackParams = getImageParameters(showType, "noimage/pas-dimage-white.png");
            if (fallbackParams && fallbackParams.url) {
                images.push({
                    url: fallbackParams.url,
                    rank: "fallback",
                });
            }
        }
        result[showType] = images;
    });

    return result;
}
